<script setup lang="ts">
    import { OffsetGroup } from '~/data/OffsetGroup'
    import { OffsetItem } from '~/data/OffsetItem'

    const { blocks } = defineProps<{ blocks: Block[] }>()
</script>

<template>
    <template v-for="block in blocks">
        <BlockTwoColumnText
            v-if="block.type === 'text_two_columns'"
            :block="block as TwoColumnTextBlock"
        />

        <BlockFeaturedProject
            v-else-if="block.type === 'featured_project'"
            :block="block as FeaturedProjectBlock"
        />

        <BlockProjectCallToAction
            v-else-if="block.type === 'project_call_to_action'"
            :block="block as ProjectCallToActionBlock"
        />

        <BlockMediaCallToAction
            v-else-if="block.type === 'media_call_to_action'"
            :block="block as MediaCallToActionBlock"
        />

        <BlockAccordions
            v-else-if="block.type === 'accordions'"
            :block="block as AccordionsBlock"
        />

        <BlockLogos
            v-else-if="block.type === 'logos'"
            :block="block as LogosBlock"
        />

        <BlockLinks
            v-else-if="block.type === 'links'"
            :block="block as LinksBlock"
        />

        <BlockMedia
            v-else-if="block.type === 'media'"
            :block="block as MediaBlock"
        />

        <div
            v-else-if="block.type === 'call_to_action'"
            class="layout-grid block-gap-y pt-8 sm:pt-12 lg:pt-32"
        >
            <BlockCallToAction
                class="max-w-[350px]"
                :class="
                    new OffsetGroup(
                        new OffsetItem(3, 3),
                        new OffsetItem(2, 2),
                        new OffsetItem(0, 1),
                    ).classes
                "
                :block="block as CallToActionBlock"
            />
        </div>
    </template>
</template>
